import { createMachine } from "xstate";
import config from "./config";
import { useMachine } from "@xstate/react";
import { useGlobalContext } from "../../global/state";
import useVendorAuthContext from "auth/context/vendor/azure/hooks/useVendorAuthContext";

const useLoginMachine = (vendor) => {
	const { dispatch } = useGlobalContext();
	const auth = useVendorAuthContext();

	const {
		state: {
			currentUser: { isLoggedIn },
		},
	} = useGlobalContext();

	const machine = createMachine({
		...config.state,
		context: {
			...config.state.context,
			...vendor,
		},
	});

	const events = {
		actions: {
			openPopup: (context, event) => {
				context?.instance.signinPopup();
			},
			setLocalStorage: (context, event) => {
				const username =
					auth.instance.user?.profile.preferred_username ||
					auth.instance.user?.profile.unique_name ||
					auth.instance.user?.profile.email;
				if (!isLoggedIn) {
					dispatch({
						type: "setCurrentUser",
						payload: {
							email: username,
							isLoggedIn: true,
						},
					});
				}
			},
		},
	};
	const [state, send, service] = useMachine(machine, events);
	return [state, send, service];
};

export default useLoginMachine;
